module.exports = __webpack_public_path__ + "static/three-health-wealth.d60a5864.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/three-health-wealth.webp
// module id = 922
// module chunks = 3